/*
* Autofocus directive.  
* 
* Apply to an input or select element using syntax like this:
* <input type='text' autofocus />
* 
*/

(function () {

    angular
        .module('ui.autofocus', [])
        .directive('autofocus', ['$timeout', autofocusDirective]);

    function autofocusDirective($timeout) {
        return {
            restrict: 'A',
            link: function (scope, element, attr) {
                $timeout(() => element[0].focus(), 0, false);
            }
        };
    }

})();